'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault2(require("@babel/runtime/regenerator"));

function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ws = require('ws');

var _ws2 = _interopRequireDefault(_ws);

var _pify = require('pify');

var _pify2 = _interopRequireDefault(_pify);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function extendWS(ws) {
  if (ws._promised) return ws;

  function promisify(method) {
    var callbackMethod = "".concat(method, "Callback");
    ws[callbackMethod] = ws[method];
    ws[method] = (0, _pify2.default)(ws[callbackMethod]);
  }

  ws._promised = true;
  promisify('send');
  promisify('ping');
  promisify('pong');
  return ws;
}

var PromiseWebSocketServer = /*#__PURE__*/function (_ws2$default$Server) {
  _inherits(PromiseWebSocketServer, _ws2$default$Server);

  var _super = _createSuper(PromiseWebSocketServer);

  function PromiseWebSocketServer() {
    _classCallCheck(this, PromiseWebSocketServer);

    return _super.apply(this, arguments);
  }

  _createClass(PromiseWebSocketServer, [{
    key: "on",
    value: function on(event, listener) {
      if (event === 'connection') {
        return _get(_getPrototypeOf(PromiseWebSocketServer.prototype), "on", this).call(this, event, function (ws) {
          return listener(extendWS(ws));
        });
      }

      return _get(_getPrototypeOf(PromiseWebSocketServer.prototype), "on", this).call(this, event, listener);
    }
  }, {
    key: "close",
    value: function close() {
      return (0, _pify2.default)(_get(_getPrototypeOf(PromiseWebSocketServer.prototype), "close", this).bind(this))();
    }
  }], [{
    key: "create",
    value: function create(options) {
      return _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var wss = new PromiseWebSocketServer(options);
                  var server = options.server,
                      noServer = options.noServer;

                  var done = function done() {
                    return resolve(wss);
                  };

                  if (noServer || server && server.listening) process.nextTick(done);else wss.once('listening', done);
                  wss.once('error', reject);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }]);

  return PromiseWebSocketServer;
}(_ws2.default.Server);

var PromiseWebSocket = /*#__PURE__*/function (_ws2$default) {
  _inherits(PromiseWebSocket, _ws2$default);

  var _super2 = _createSuper(PromiseWebSocket);

  function PromiseWebSocket() {
    var _this;

    _classCallCheck(this, PromiseWebSocket);

    _this = _super2.apply(this, arguments);
    extendWS(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PromiseWebSocket, null, [{
    key: "create",
    value: function create() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new Promise(function (resolve, reject) {
        var ws = new (Function.prototype.bind.apply(PromiseWebSocket, [null].concat(args)))();
        ws.once('open', function () {
          return resolve(ws);
        });
        ws.once('error', reject);
      });
    }
  }]);

  return PromiseWebSocket;
}(_ws2.default);

exports.default = PromiseWebSocket;
PromiseWebSocket.Server = PromiseWebSocketServer;
PromiseWebSocket.WebSocket = _ws2.default;